export default __webpack_public_path__ + "static/media/vista-vacia-forma-de-pago.864095df.svg";